import store from '@/store';
import { insuranceRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
    const { values } = store.state.formData;
    const insuranceType = getValueByFieldName(values, FIELD_NAMES.insuranceType);
    const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
    const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
    const email = getValueByFieldName(values, FIELD_NAMES.email);
    const emirateID = getValueByFieldName(values, FIELD_NAMES.emiratesID);
    const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
    const insuranceConsent = getValueByFieldName(values, FIELD_NAMES.consent);
    
    return {
        "insurance": {
            "type-of-insurance": insuranceType,
            "emirates-id-num": emirateID,
            "first-name": firstName,
            "last-name": lastName,
            "email-address": email,
            "mobile-number": phone,
            "consent": typeof insuranceConsent !== 'undefined' ? 'Y' : 'N'
        }

    };
};

export default {
    async insurance(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: insuranceRepository.insurance,
            payload: getPayload(),
        });
        if (response) {
            return response['status'];
        }
    }
};
